export default __webpack_public_path__ + "static/media/small-cross.817b516f.svg";